// Top-level route patterns consumed by Sentry's React Router v5 browser tracing
// integration. Kept in sync with the `<Switch>` order in `src/routes.js` so that
// transaction names render as parametric patterns (e.g. `/create-new-account/:token/`)
// instead of URL-instantiated paths.
//
// This file is intentionally separate from `routes.js`: `configure.js` runs at module
// load (imported first by `index.js`) and importing the full `routes.js` tree at init
// time would force every page chunk to evaluate before Sentry initializes.
export const sentryRoutes = [
  { path: '/maintenance/' },
  { path: '/brands/web-embed-preview/' },
  { path: '/login/complete-jit/' },
  { path: '/login/two-factor/' },
  { path: '/login/sso/complete/' },
  { path: '/login/sso/' },
  { path: '/login/' },
  { path: '/signup/complete-sso-signup/' },
  { path: '/signup/complete/' },
  { path: '/signup/' },
  { path: '/404/' },
  { path: '/oauth/intercom/' },
  { path: '/oauth/connect/' },
  { path: '/reset-password' },
  { path: '/check-email' },
  { path: '/check-verify-email' },
  { path: '/invalid-password-token' },
  { path: '/invalid-invite-token' },
  { path: '/create-new-password' },
  { path: '/create-new-account/:token/' },
  { path: '/dashboards' },
  { path: '/customers' },
  { path: '/team-members' },
  { path: '/reports' },
  { path: '/feedback' },
  { path: '/responses' },
  { path: '/success-dashboard' },
  { path: '/settings' },
  { path: '/profile' },
  { path: '/survey' },
  { path: '/oauth' },
  { path: '/billing' },
  { path: '/workspaces/' },
  { path: '/:workspaceToken/onboarding/' },
  { path: '/:workspaceToken/' },
  { path: '/' },
]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/config/sentryRoutes.js